// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2N_uj","title":"InfoRow_title__2C_o7"};